import React from 'react';

interface Props {
	size: number;
}

export const AccountingIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 23.19 22.62'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>accounting</title>
		<path d='M11 22.62a11 11 0 010-22h.3a.41.41 0 01.41.42.43.43 0 01-.43.41H11a10.18 10.18 0 1010.2 10.42.45.45 0 01.43-.41.43.43 0 01.41.42A11 11 0 0111 22.62z' />
		<path d='M22.77 8.87h-8a.42.42 0 01-.42-.43v-8a.39.39 0 01.13-.3.41.41 0 01.3-.12 8.66 8.66 0 018.43 8.43.39.39 0 01-.12.31.42.42 0 01-.32.11zM15.17 8h7.16A7.82 7.82 0 0015.17.87z' />
	</svg>
);
